(function () {
  var logPrefix = '[LoyaltyLion Auto Discount]';
  console.log('[LoyaltyLion Auto Discount] VERSION sessionStorage-v2');
  var maxWaitMs = 15000;
  var startedAt = Date.now();
  var hookRegistered = false;
  var openCartFlagKey = 'll_open_cart_after_discount';

  function log(message, data) {
    if (data !== undefined) console.log(logPrefix, message, data);
    else console.log(logPrefix, message);
  }

  function warn(message, data) {
    if (data !== undefined) console.warn(logPrefix, message, data);
    else console.warn(logPrefix, message);
  }

  function getReturnUrl() {
    var url = new URL(window.location.href);
    url.searchParams.set('ll_open_cart', '1');
    return url.pathname + url.search + url.hash;
  }

  function applyDiscountCode(code) {
    var returnUrl = getReturnUrl();

    try {
      sessionStorage.setItem(openCartFlagKey, '1');
    } catch (error) {
      warn('Could not write open cart flag to sessionStorage.', error);
    }

    var discountUrl =
      '/discount/' +
      encodeURIComponent(code) +
      '?redirect=' +
      encodeURIComponent(returnUrl);

    log('Redirecting to Shopify discount URL', discountUrl);
    window.location.href = discountUrl;
  }

  function openLcuCart() {
    var attempts = 0;
    var maxAttempts = 30;

    function tryOpen() {
      attempts += 1;

      var trigger = document.querySelector('#cart-icon-bubble, .header__icon--cart');

      if (trigger) {
        log('Found cart trigger. Clicking existing cart trigger for LCU smart cart.', trigger);

        trigger.dispatchEvent(
          new MouseEvent('click', {
            bubbles: true,
            cancelable: true,
            view: window,
          })
        );

        return;
      }

      if (attempts < maxAttempts) {
        window.setTimeout(tryOpen, 500);
        return;
      }

      warn('Cart trigger was not found after retries.');
    }

    tryOpen();
  }

  function shouldOpenCartAfterRedirect() {
    var url = new URL(window.location.href);
    var hasUrlFlag = url.searchParams.get('ll_open_cart') === '1';
    var hasStorageFlag = false;

    try {
      hasStorageFlag = sessionStorage.getItem(openCartFlagKey) === '1';
    } catch (error) {
      warn('Could not read open cart flag from sessionStorage.', error);
    }

    log('Checking open cart after redirect.', {
      hasUrlFlag: hasUrlFlag,
      hasStorageFlag: hasStorageFlag,
      currentUrl: window.location.href
    });

    return hasUrlFlag || hasStorageFlag;
  }

  function clearOpenCartFlags() {
    var url = new URL(window.location.href);

    if (url.searchParams.get('ll_open_cart') === '1') {
      url.searchParams.delete('ll_open_cart');
      window.history.replaceState({}, document.title, url.pathname + url.search + url.hash);
    }

    try {
      sessionStorage.removeItem(openCartFlagKey);
    } catch (error) {
      warn('Could not clear open cart flag from sessionStorage.', error);
    }
  }

  function openCartAfterDiscountRedirect() {
    if (!shouldOpenCartAfterRedirect()) return;

    clearOpenCartFlags();

    log('Will attempt to open LCU smart cart after discount redirect.');
    window.setTimeout(openLcuCart, 2500);
  }

  function registerHookOnce() {
    if (hookRegistered) return;

    if (!window.loyaltylion || typeof window.loyaltylion.registerHook !== 'function') {
      return;
    }

    hookRegistered = true;
    log('Registering customers.rewards.claimed hook.');

    window.loyaltylion.registerHook(
      'customers.rewards.claimed',
      async function ({ claimedReward }) {
        log('customers.rewards.claimed fired.', claimedReward);

        var code =
          claimedReward &&
          claimedReward.redeemable &&
          claimedReward.redeemable.code;

        if (!code) {
          warn('No claimedReward.redeemable.code found. Showing LoyaltyLion claim modal.', claimedReward);
          return { action: 'show_claim_modal' };
        }

        applyDiscountCode(code);

        return { action: 'hide_claim_modal' };
      }
    );
  }

  function waitForLoyaltyLion() {
    if (!window.loyaltylion || typeof window.loyaltylion.on !== 'function') {
      if (Date.now() - startedAt >= maxWaitMs) {
        warn('LoyaltyLion SDK was not found after waiting.');
        return;
      }

      window.setTimeout(waitForLoyaltyLion, 250);
      return;
    }

    log('LoyaltyLion SDK found.');

    registerHookOnce();
    window.loyaltylion.on('ready', registerHookOnce);
  }

  log('Script loaded.');
  openCartAfterDiscountRedirect();
  waitForLoyaltyLion();
})();